export const RESOURCE_TOKENS_DETAIL = `
    _id
    valid_from
    valid_to
    access_type
    height
    width
    status
    resource_type
    resource_id
    show_header
    show_filters_area
    resource_data {
        _id
        name
    }
`;

export const RESOURCE_TOKENS_BASIC = `
    _id
    valid_from
    valid_to
    access_type
    height
    width
    status
    resource_type
    resource_id
    show_header
    show_filters_area
`;

export const RESOURCE_TOKENS_MINIMAL = `
    resourceId
    resourceType
    show_header
    show_filters_area
`;